<button
    type="button"
    class="button-tooltip"
    triggers="click"
    [autoClose]="'outside'"
    [ngbTooltip]="textoAviso">
        <fa-icon [icon]="faQuestion"></fa-icon>
</button>